import React, { Component } from "react";
import PropTypes from "prop-types";
import { TitleCase } from "../../common";
import { Form, Button, Loader } from "semantic-ui-react";

class ApproveReject extends Component {
  constructor(props) {
    super(props);
    var monthNames = [
      "JAN",
      "FEB",
      "MAR",
      "APR",
      "MAY",
      "JUN",
      "JUL",
      "AUG",
      "SEP",
      "OCT",
      "NOV",
      "DEC"
    ];
    var date = new Date();
    date =
      date.getDate() +
      " " +
      TitleCase(monthNames[date.getMonth()]) +
      " " +
      date.getFullYear();

    this.state = {
      note: "",
      error: false,
      submitted: false,
      isFocused: false
    };
  }

  ApproveReject(e) {
    e.preventDefault();

    this.setState({ submitted: true });
    this.props.onApproveReject(this.state.note);
  }

  renderError() {
    return <div></div>;
  }

  onFocus() {
    this.setState({ isFocused: true });
  }

  onBlur() {
    this.setState({ isFocused: false });
  }

  handleChange(e) {
    this.setState({ note: e.target.value });
  }

  renderApproveReject() {
    if (this.props.postingStatus === "busy") {
      return (
        <form className="ui form">
          <Loader active size="large" inline="centered">
            Loading
          </Loader>
        </form>
      );
    }

    return (
      <div
        style={{
          width: "100%",
          paddingLeft: this.props.tablet ? "60px" : "40px",
          paddingRight: this.props.tablet ? "60px" : "40px"
        }}
        className="ui form login"
      >
        <form>
          <div className="formControlItem">
            <Form.Field>
              {this.renderError()}
              <label style={{ fontWeight: "bold", fontSize: "15px" }}>
                Note
              </label>
              <div>
                <textarea
                  type="text"
                  multiline={true}
                  numberOfLines={5}
                  style={{ width: "100%" }}
                  autoFocus
                  id="name"
                  placeholder=""
                  value={this.state.note}
                  onChange={e => this.handleChange(e)}
                />
              </div>
              <br></br>
              <Button
                style={{ width: "100%" }}
                className="ui active button"
                role="button"
                onClick={this.ApproveReject.bind(this)}
              >
                Submit
              </Button>
            </Form.Field>
          </div>
        </form>
      </div>
    );
  }

  render() {
    return <div style={{ flex: 1 }}>{this.renderApproveReject()}</div>;
  }
}

ApproveReject.propTypes = {
  form_title: PropTypes.string.isRequired,
  storeColour: PropTypes.object.isRequired
};

export default ApproveReject;



// WEBPACK FOOTER //
// ./src/components/ApproveReject/index.js